module.exports = __webpack_public_path__ + "img/rack.cd34f84a.jpg";